import type { QueryClient } from '@tanstack/react-query'
import { BANKING_KEYS, CASH_POSITION_SUMMARIES_KEY, PROJECTION_KEYS } from '@/lib/query-keys'

/**
 * Invalidates what a projection write can change: all projection lists, the
 * Cash Position report, and the per-import projection list and count behind an
 * import's "See details" (a projection may belong to an import).
 */
export function invalidateAfterProjectionWrite(queryClient: QueryClient): void {
  queryClient.invalidateQueries({ queryKey: PROJECTION_KEYS.all })
  queryClient.invalidateQueries({ queryKey: CASH_POSITION_SUMMARIES_KEY })
  queryClient.invalidateQueries({ queryKey: BANKING_KEYS.allFileImportProjections })
}

/**
 * Invalidates what deleting a projection import changes: everything a
 * projection write does, plus the Import History list and count. The deleted
 * row's by-id entry is dropped rather than refetched — there is nothing left
 * to read.
 */
export function invalidateAfterProjectionImportDelete(
  queryClient: QueryClient,
  organizationId: string,
  fileImportId: string,
): void {
  invalidateAfterProjectionWrite(queryClient)
  queryClient.invalidateQueries({ queryKey: BANKING_KEYS.allFileImports })
  queryClient.removeQueries({ queryKey: BANKING_KEYS.fileImportById(organizationId, fileImportId) })
}
